export default __webpack_public_path__ + "static/media/person.e346253a.svg";